import { KEY_CODES } from '@monofront/business/constants';
import React, { useState } from 'react';
import { useTranslations } from 'use-intl';

interface IOption<ValueType> {
  id: string;
  label: string;
  value: ValueType;
}
interface IAutoCompleteProps<ValueType> {
  options?: IOption<ValueType>[];
  isLoading?: boolean;
  suggestionsListBlockStyle?: object;
  renderInput: (ValueType) => React.ReactElement<any>;
  handleSelect: (ValueType) => void;
}

export type IAutoComplete<ValueType = any> = React.FC<
  IAutoCompleteProps<ValueType>
>;

const AutoComplete: IAutoComplete = ({
  options,
  isLoading,
  suggestionsListBlockStyle,
  renderInput,
  handleSelect,
}) => {
  const [areSuggestionsVisible, setAreSuggestionsVisible] = useState(false);
  const tGlobal = useTranslations('Global');

  return (
    <>
      {renderInput({
        // Hide suggestions on press enter
        onKeyDown: (e: React.KeyboardEvent) => {
          if (e.keyCode === KEY_CODES.ENTER && areSuggestionsVisible) {
            setAreSuggestionsVisible(false);
          } else if (!areSuggestionsVisible) {
            setAreSuggestionsVisible(true);
          }
        },
        onBlur: () => setAreSuggestionsVisible(false),
        onFocus: () => setAreSuggestionsVisible(true),
      })}
      {areSuggestionsVisible && options && options.length > 0 && (
        <ul className="suggestions" style={suggestionsListBlockStyle}>
          {isLoading ? (
            <li>{tGlobal('loading')}...</li>
          ) : (
            options.map((option) => (
              <li
                data-testid="AddressForm-Input-suggestion"
                key={option.id}
                className="pointer"
                onMouseDown={() => handleSelect(option.value)}
                onTouchStart={() => handleSelect(option.value)}
              >
                {option.label}
              </li>
            ))
          )}
        </ul>
      )}
      <style jsx>
        {`
          .suggestions {
            position: absolute;
            background-color: white;
            border: var(--border);
            padding: var(--space-3);
            z-index: var(--zindex-fixed);
            box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.08);
            margin-left: var(--space-4);
            width: calc(100% - 2 * var(--space-4));
          }

          .suggestions li {
            font-size: var(--font-size-2);
            padding: var(--space-1);
          }

          .suggestions li:hover {
            transition: all 0.3s ease;
            background-color: var(--clr-primary-5);
          }
        `}
      </style>
    </>
  );
};

export default AutoComplete;
